// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1nZ7e","icon":"SortAdornment_icon__1LWax","up":"SortAdornment_up__3Fhsw","down":"SortAdornment_down__312zQ","active":"SortAdornment_active__1Z6O5"};